import React from "react";
import PropTypes from "prop-types";

import LogoTitle from "../../../LogoTitle/LogoTitle";
import FloatLabel from "../../../FloatLabel/FloatLabel";
import { msisdnMask } from "../../../../../lib/utils";
import logoRecharge from "../../../../../images/landing_logo_recarga.svg";

const MsisdnForm = ({ msisdn, setMsisdn }) => {
  return (
    <>
      <LogoTitle
        src={logoRecharge}
        alt="Recargas"
        text="Faça uma recarga e aproveite para falar e navegar ainda mais."
        titleMaxWidth={240}
      />
      <FloatLabel
        type="tel"
        size={15}
        maxLength={15}
        placeholder="Digite seu nº claro"
        onChange={e => {
          setMsisdn(e.target.value);
        }}
        value={msisdnMask(msisdn)}
        autoFocus
      />
    </>
  );
};

MsisdnForm.propTypes = {
  msisdn: PropTypes.string.isRequired,
  setMsisdn: PropTypes.func.isRequired,
};

export default MsisdnForm;
